import {BrowserRouter, Routes, Route, Navigate, useParams} from 'react-router-dom'
import {AuthProvider} from '@/hooks/platform/use-auth'
import {ViewAsPartnerProvider} from '@/hooks/platform/use-view-as-partner'
import {ProtectedRoute} from '@/components/protected-route'
import {AppLayout} from '@/components/app-layout'
import {AvisosRegion} from '@/components/avisos-region'
import {LandingPage} from '@/pages/producto/landing'
import {LoginPage} from '@/pages/platform/login'
import {ClaimPage, ResetPage} from '@/pages/platform/set-password'
import {ResetRequestPage} from '@/pages/empresa/identidad/reset-request'
import {VerificarCorreoPage} from '@/pages/empresa/identidad/verificar-correo'
import {CargaIpsPublicaPage} from '@/pages/salud/medicina_laboral/carga-ips-publica'
import {RegistroPage} from '@/pages/empresa/identidad/registro'
import {RegistroEmpresaPage} from '@/pages/empresa/identidad/registro-empresa'
import {ManualIndexPage} from '@/pages/producto/manual/manual-index'
import {ManualSeccionPage} from '@/pages/producto/manual/manual-seccion'
import {HomePage} from '@/pages/producto/home'
import {BusinessesPage} from '@/pages/inci/consola/businesses'
import {AdminLicenciasPage} from '@/pages/inci/consola/admin-licencias'
import {AdminsPage} from '@/pages/inci/consola/admins'
import {UsuariosPage} from '@/pages/inci/consola/usuarios'
import {PartnersPage} from '@/pages/inci/aliados/partners'
import {PartnerDetailPage} from '@/pages/inci/aliados/partner-detail'
import {PartnerPanelPage} from '@/pages/inci/aliados/partner-panel'
import {AdminBateriaPage} from '@/pages/bateria/admin-bateria'
import {AdminBateriaSolicitudesPage} from '@/pages/bateria/admin-bateria-solicitudes'
import {AdminBateriaAdhocPage} from '@/pages/bateria/admin-bateria-adhoc'
import {AdminSstPage} from '@/pages/inci/consola/admin-sst'
import {AdminCatalogoPage} from '@/pages/inci/catalogo/admin-catalogo'
import {AdminValoresEconomicosPage} from '@/pages/inci/consola/admin-valores-economicos'
import {CarteraPage} from '@/pages/inci/cartera/cartera'
import {EmpresaPanelPage} from '@/pages/inci/consola/empresa-panel'
import {AdminBateriaEvaluacionPage} from '@/pages/bateria/admin-bateria-evaluacion'
import {AdminBateriaInformePage} from '@/pages/bateria/admin-bateria-informe'
import {AdminBateriaColaPage} from '@/pages/bateria/admin-bateria-cola'
import {AdminBateriaDigitacionPage} from '@/pages/bateria/admin-bateria-digitacion'
import {BusinessHomePage} from '@/pages/sgsst/resumen/business-home'
import {RutaPage} from '@/pages/sgsst/resumen/ruta'
import {BusinessProfilePage} from '@/pages/empresa/organizacion/business-profile'
import {PlanFacturacionPage} from '@/pages/inci/cartera/plan-facturacion'
import {CarpetasVisitaPage} from '@/pages/salud/carpeta_visita/carpetas-visita'
import {CifrasEmpresaPage} from '@/pages/empresa/organizacion/cifras-empresa'
import {CuarentenaPage} from '@/pages/salud/medicina_laboral/cuarentena'
import {OrganigramaPage} from '@/pages/empresa/organizacion/organigrama'
import {BateriaPage} from '@/pages/bateria/bateria'
import {PlanTrabajoPage} from '@/pages/sgsst/plan/plan-trabajo'
import {PerfilRiesgoPage} from '@/pages/salud/perfil_riesgo/perfil-riesgo'
import {MiPerfilPage} from '@/pages/empresa/identidad/mi-perfil'
import {MiFichaPage} from '@/pages/empresa/identidad/mi-ficha'
import {MiInformacionPage} from '@/pages/empresa/identidad/mi-informacion'
import {MiPerfilSociodemograficoPage} from '@/pages/empresa/mi_espacio/mi-perfil-sociodemografico'
import {EmployeesPage} from '@/pages/empresa/identidad/employees'
import {ProveedoresPage} from '@/pages/empresa/proveedores/proveedores'
import {EmployeeDetailPage} from '@/pages/empresa/identidad/employee-detail'
import {ExamenesMatrizPage} from '@/pages/sgsst/evidencias/examenes-matriz'
import {SgsstPage} from '@/pages/sgsst/evaluacion/sgsst'
import {MatrizLegalPage} from '@/pages/sgsst/matriz_legal/matriz-legal'
import {IndicadoresPage} from '@/pages/sgsst/indicadores/indicadores'
import {CertificacionContenidoPage} from '@/pages/sgsst/expediente/certificacion-contenido'
import {MatrizRiesgosPage} from '@/pages/sgsst/riesgos/matriz-riesgos'
import {PerfilCargoDetallePage} from '@/pages/empresa/perfil_cargo/perfil-cargo-detalle'
import {DecisionIngresoPage} from '@/pages/empresa/obras/decision-ingreso'
import {ObraDetallePage} from '@/pages/empresa/obras/obra-detalle'
import {ObrasPage} from '@/pages/empresa/obras/obras'
import {IpsPage} from '@/pages/salud/medicina_laboral/ips'
import {PerfilCargoAprendePage} from '@/pages/empresa/perfil_cargo/perfil-cargo-aprende'
import {PerfilCargoCondicionesPage} from '@/pages/empresa/perfil_cargo/perfil-cargo-condiciones'
import {PerfilCargoVersionesPage} from '@/pages/empresa/perfil_cargo/perfil-cargo-versiones'
import {PerfilesCargoConfirmarPage} from '@/pages/empresa/perfil_cargo/perfiles-cargo-confirmar'
import {SolicitudesIpsPage} from '@/pages/salud/medicina_laboral/solicitudes-ips'
import {PerfilesCargoPage} from '@/pages/empresa/perfil_cargo/perfiles-cargo'
import {PreguntasCargoPage} from '@/pages/empresa/perfil_cargo/preguntas-cargo'
import {RejillaCargoPage} from '@/pages/empresa/cumplimiento/rejilla-cargo'
import {RequisitosCargoPage} from '@/pages/empresa/perfil_cargo/requisitos-cargo'
import {SgsstPendientesPage} from '@/pages/sgsst/evaluacion/sgsst-pendientes'
import {SgsstPlanPage} from '@/pages/sgsst/plan/sgsst-plan'
import {SgsstPlanPropuestaPage} from '@/pages/sgsst/plan/sgsst-plan-propuesta'
import {SgsstHistoryPage} from '@/pages/sgsst/evaluacion/sgsst-history'
import {ExpedientePage} from '@/pages/sgsst/expediente/expediente'
import {ExpedienteMatrizRiesgosPage} from '@/pages/sgsst/expediente/expediente-matriz-riesgos'
import {ExpedienteMatrizLegalPage} from '@/pages/sgsst/expediente/expediente-matriz-legal'
import {ExpedienteBateriaPage} from '@/pages/sgsst/expediente/expediente-bateria'
import {PerfilAgregadosPage} from '@/pages/salud/perfil_riesgo/perfil-agregados'
import {MiCumplimientoPage} from '@/pages/empresa/mi_espacio/mi-cumplimiento'
import {MiSoportesPage} from '@/pages/empresa/mi_espacio/mi-soportes'
import {MiSolicitudesPage} from '@/pages/sgsst/evidencias/mi-solicitudes'
import {MiSoportesSolicitudesPage} from '@/pages/empresa/mi_espacio/mi-soportes-solicitudes'
import {MiAccionesPage} from '@/pages/empresa/mi_espacio/mi-acciones'
import {MiAreaPage} from '@/pages/empresa/organizacion/mi-area'
import {IncidentesPage} from '@/pages/sgsst/incidentes/incidentes'
import {IncidenteReportarPage} from '@/pages/sgsst/incidentes/incidente-reportar'
import {IncidenteDetallePage} from '@/pages/sgsst/incidentes/incidente-detalle'
import {IncapacidadReportarPage} from '@/pages/empresa/mi_espacio/incapacidad-reportar'
import {InvestigacionPage} from '@/pages/sgsst/incidentes/investigacion'
import {NotificationsPage} from '@/pages/producto/notificaciones/notifications'
import {NotFoundPage} from '@/pages/common/not-found'
import {FeedbackArchivoPage} from '@/pages/producto/feedback/feedback-archivo'

/** Los enlaces guardados a la revisión por paquete, ya retirada, reentran por la cola de esa persona. */
function RevisionDePaqueteRedirect() {
  const {businessId, evaluacionId, paqueteId} = useParams()
  return (
    <Navigate
      to={`/admin/bateria/empresas/${businessId}/evaluaciones/${evaluacionId}/revision?paquete_id=${paqueteId}`}
      replace
    />
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ViewAsPartnerProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/claim" element={<ClaimPage />} />
            <Route path="/reset" element={<ResetPage />} />
            <Route path="/reset-request" element={<ResetRequestPage />} />
            <Route path="/verificar-correo" element={<VerificarCorreoPage />} />
            {/* PQ-7b. Sin ProtectedRoute a propósito: la IPS no tiene cuenta y el token viaja en el
              fragmento de la URL, que el navegador nunca manda al servidor. */}
            <Route path="/carga-ips" element={<CargaIpsPublicaPage />} />
            {/* Before /registro/:token so the literal /registro/empresa wins. */}
            <Route path="/registro/empresa" element={<RegistroEmpresaPage />} />
            <Route path="/registro/:token" element={<RegistroPage />} />
            {/* The one public exception: a signed-out visitor gets the landing at "/" instead of /login. */}
            <Route element={<ProtectedRoute publicFallback={<LandingPage />} />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<HomePage />} />
              </Route>
            </Route>
            {/* The same landing for signed-in users; its canonical link points back at "/". */}
            <Route path="/inicio" element={<LandingPage />} />
            {/* Public, no auth: prospects read the manual before having an account. */}
            <Route path="/manual" element={<ManualIndexPage />} />
            <Route path="/manual/:seccionId" element={<ManualSeccionPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/admin/empresas" element={<BusinessesPage />} />
                <Route path="/admin/admins" element={<AdminsPage />} />
                {/* KAI-158 */}
                <Route path="/admin/usuarios" element={<UsuariosPage />} />
                <Route path="/admin/partners" element={<PartnersPage />} />
                <Route path="/admin/partners/:partnerId" element={<PartnerDetailPage />} />
                {/* Guarded by is_partner. */}
                <Route path="/partner" element={<PartnerPanelPage />} />
                <Route path="/admin/licencias" element={<AdminLicenciasPage />} />
                {/* La empresa es el sujeto de la evaluación, no un tenant: el detalle vive bajo /admin/bateria. */}
                <Route path="/admin/bateria" element={<AdminBateriaPage />} />
                <Route path="/admin/bateria-solicitudes" element={<AdminBateriaSolicitudesPage />} />
                {/* D-ADHOC: empresas que no son tenant de Kairos. */}
                <Route path="/admin/bateria/adhoc" element={<AdminBateriaAdhocPage />} />
                <Route path="/admin/sst" element={<AdminSstPage />} />
                {/* The yearly UVT/SMMLV table that feeds the fine exposure (Decreto 2642/2022). */}
                <Route path="/admin/valores-economicos" element={<AdminValoresEconomicosPage />} />
                <Route path="/admin/catalogo" element={<AdminCatalogoPage />} />
                <Route path="/admin/cartera" element={<CarteraPage />} />
                {/* KAI-353: destino del enlace que arma el backend (`enlace_archivo`) para el issue de Plane. */}
                <Route path="/admin/feedback/:reporteId/archivos/:archivoId" element={<FeedbackArchivoPage />} />
                <Route path="/admin/empresas/:businessId" element={<EmpresaPanelPage />} />
                <Route
                  path="/admin/bateria/empresas/:businessId/evaluaciones/:evaluacionId"
                  element={<AdminBateriaEvaluacionPage />}
                />
                <Route
                  path="/admin/bateria/empresas/:businessId/evaluaciones/:evaluacionId/informe"
                  element={<AdminBateriaInformePage />}
                />
                {/* El flujo por persona es esta misma pantalla con `?paquete_id=`. */}
                <Route
                  path="/admin/bateria/empresas/:businessId/evaluaciones/:evaluacionId/revision"
                  element={<AdminBateriaColaPage />}
                />
                <Route
                  path="/admin/bateria/empresas/:businessId/evaluaciones/:evaluacionId/paquetes/:paqueteId/revision"
                  element={<RevisionDePaqueteRedirect />}
                />
                <Route
                  path="/admin/bateria/empresas/:businessId/evaluaciones/:evaluacionId/paquetes/:paqueteId/digitacion"
                  element={<AdminBateriaDigitacionPage />}
                />
                <Route path="/admin/businesses/:businessId" element={<Navigate to="/admin/bateria" replace />} />
                <Route path="/businesses/:businessId" element={<BusinessHomePage />} />
                <Route path="/businesses/:businessId/ruta" element={<RutaPage />} />
                <Route path="/businesses/:businessId/profile" element={<BusinessProfilePage />} />
                <Route path="/businesses/:businessId/plan" element={<PlanFacturacionPage />} />
                {/* PQ-1 */}
                <Route path="/businesses/:businessId/cifras" element={<CifrasEmpresaPage />} />
                {/* PQ-9 (E10-H16) */}
                <Route path="/businesses/:businessId/obras" element={<ObrasPage />} />
                <Route path="/businesses/:businessId/obras/:proyectoId" element={<ObraDetallePage />} />
                {/* PQ-10 (E10-H12) */}
                <Route
                  path="/businesses/:businessId/obras/:proyectoId/ingreso/:employeeId"
                  element={<DecisionIngresoPage />}
                />
                <Route path="/businesses/:businessId/organigrama" element={<OrganigramaPage />} />
                <Route path="/businesses/:businessId/bateria" element={<BateriaPage />} />
                <Route path="/businesses/:businessId/plan-trabajo" element={<PlanTrabajoPage />} />
                <Route path="/businesses/:businessId/perfil-riesgo" element={<PerfilRiesgoPage />} />
                <Route path="/businesses/:businessId/mi/perfil" element={<MiPerfilPage />} />
                {/* The old routes stay so saved links and the registration redirect keep working. */}
                <Route path="/businesses/:businessId/mi/informacion" element={<MiInformacionPage />} />
                <Route path="/businesses/:businessId/mi/ficha" element={<MiFichaPage />} />
                <Route
                  path="/businesses/:businessId/mi/perfil-sociodemografico"
                  element={<MiPerfilSociodemograficoPage />}
                />
                <Route path="/businesses/:businessId/employees" element={<EmployeesPage />} />
                <Route path="/businesses/:businessId/empleados/:employeeId" element={<EmployeeDetailPage />} />
                <Route path="/businesses/:businessId/proveedores" element={<ProveedoresPage />} />
                <Route path="/businesses/:businessId/examenes" element={<ExamenesMatrizPage />} />
                <Route path="/businesses/:businessId/sgsst" element={<SgsstPage />} />
                <Route path="/businesses/:businessId/sgsst/matriz-riesgos" element={<MatrizRiesgosPage />} />
                <Route path="/businesses/:businessId/sgsst/matriz-legal" element={<MatrizLegalPage />} />
                <Route path="/businesses/:businessId/sgsst/indicadores" element={<IndicadoresPage />} />
                <Route
                  path="/businesses/:businessId/sgsst/certificaciones/:artefacto"
                  element={<CertificacionContenidoPage />}
                />
                <Route path="/businesses/:businessId/sgsst/pendientes" element={<SgsstPendientesPage />} />
                {/* PQ-2a (E10-H01) */}
                <Route path="/businesses/:businessId/sgsst/perfiles-cargo" element={<PerfilesCargoPage />} />
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId"
                  element={<PerfilCargoDetallePage />}
                />
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId/condiciones"
                  element={<PerfilCargoCondicionesPage />}
                />
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId/aprende"
                  element={<PerfilCargoAprendePage />}
                />
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId/versiones"
                  element={<PerfilCargoVersionesPage />}
                />
                {/* PQ-2d (E10-H04) */}
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId/preguntas"
                  element={<PreguntasCargoPage />}
                />
                {/* PQ-3 (E10-H05, H06) */}
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/:positionId/requisitos"
                  element={<RequisitosCargoPage />}
                />
                <Route
                  path="/businesses/:businessId/sgsst/perfiles-cargo/confirmar"
                  element={<PerfilesCargoConfirmarPage />}
                />
                {/* PQ-4 (E10-H11). Cuelga de `positions` porque la spec fija ahí la familia del recurso;
                  moverla arrastra EXPECTED_ROUTES, los hooks y las historias E2E. */}
                <Route
                  path="/businesses/:businessId/sgsst/positions/:positionId/rejilla"
                  element={<RejillaCargoPage />}
                />
                {/* PQ-6 (E1-H01/H03) */}
                <Route path="/businesses/:businessId/ips" element={<IpsPage />} />
                <Route path="/businesses/:businessId/solicitudes-ips" element={<SolicitudesIpsPage />} />
                {/* PQ-5 (E10-H15) */}
                <Route path="/businesses/:businessId/sgsst/carpetas-visita" element={<CarpetasVisitaPage />} />
                {/* PQ-7d (E1-H05). Solo la abre quien custodia el dato de salud. */}
                <Route path="/businesses/:businessId/cuarentena" element={<CuarentenaPage />} />
                <Route path="/businesses/:businessId/sgsst/plan" element={<SgsstPlanPage />} />
                <Route path="/businesses/:businessId/sgsst/plan/propuesta" element={<SgsstPlanPropuestaPage />} />
                <Route path="/businesses/:businessId/sgsst/historial" element={<SgsstHistoryPage />} />
                <Route path="/businesses/:businessId/expediente/:year" element={<ExpedientePage />} />
                <Route
                  path="/businesses/:businessId/expediente/:year/matriz-riesgos"
                  element={<ExpedienteMatrizRiesgosPage />}
                />
                <Route
                  path="/businesses/:businessId/expediente/:year/matriz-legal"
                  element={<ExpedienteMatrizLegalPage />}
                />
                <Route path="/businesses/:businessId/expediente/:year/bateria" element={<ExpedienteBateriaPage />} />
                <Route path="/businesses/:businessId/sgsst/perfil-agregados" element={<PerfilAgregadosPage />} />
                {/* Old routes stay for the same reason as «Mi información». */}
                {/* PQ-12 (E10-H13) */}
                <Route path="/businesses/:businessId/mi/cumplimiento" element={<MiCumplimientoPage />} />
                <Route path="/businesses/:businessId/mi/soportes-solicitudes" element={<MiSoportesSolicitudesPage />} />
                <Route path="/businesses/:businessId/mi/soportes" element={<MiSoportesPage />} />
                <Route path="/businesses/:businessId/mi/solicitudes" element={<MiSolicitudesPage />} />
                <Route path="/businesses/:businessId/mi/acciones" element={<MiAccionesPage />} />
                <Route path="/businesses/:businessId/mi-area" element={<MiAreaPage />} />
                <Route path="/businesses/:businessId/incidentes" element={<IncidentesPage />} />
                <Route path="/businesses/:businessId/incidentes/reportar" element={<IncidenteReportarPage />} />
                <Route path="/businesses/:businessId/incidentes/:incidenteId" element={<IncidenteDetallePage />} />
                <Route path="/businesses/:businessId/incapacidades/reportar" element={<IncapacidadReportarPage />} />
                <Route
                  path="/businesses/:businessId/incidentes/:incidenteId/investigacion"
                  element={<InvestigacionPage />}
                />
                <Route path="/notifications" element={<NotificationsPage />} />
                {/* The business-scoped 404 keeps `:businessId` so the per-business nav stays. */}
                <Route path="/businesses/:businessId/*" element={<NotFoundPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          </Routes>
          <AvisosRegion />
        </ViewAsPartnerProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
